import { useEffect, useState } from "react";
import { getRoles } from "../../api/role-api";
import { getAcls } from "../../api/acl-api";
import Overlay from '../overlays/editRole';
import { useLanguage } from "../../providers/preferenceProvider";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare, faPlus } from '@fortawesome/free-solid-svg-icons';
import { getRoomsPlain } from "../../api/room-api";

const Roles = () => {
  const [roles, setRoles] = useState([]);
  const [acls, setAcls] = useState([]);
  const [rooms, setRooms] = useState([]);
  const [showOverlay, setShowOverlay] = useState(false);
  const [overlayRole, setOverlayRole] = useState(null);
  const [createNew, setCreateNew] = useState(false);
  const { t } = useLanguage();

  async function fetchRoles() {
    getRoles().then((response) => {
      setRoles(response.data);
    });
  }

  async function fetchOptions() {
    getAcls().then((response) => {
      setAcls(response.data);
    });

    getRoomsPlain().then((response) => {
      setRooms(response.data);
    });
  }
    
  useEffect(() => {
    fetchRoles();
    fetchOptions();
  }, []);

  function closeOverlay() {
    setShowOverlay(false);
    setOverlayRole(null);
  }

  const handleEditRole = (role) => {
    setCreateNew(false);
    setOverlayRole(role);
    setShowOverlay(true);
  };

  const handleAddRole = () => {
    setCreateNew(true);
    setOverlayRole(null);
    setShowOverlay(true);
  };

  return (
    <>
      <div className="admin-list-wrapper">
        <div className="admin-list-header mb-4 flex justify-between items-center">
          <div>{t.amount_of + " " + t.roles + ": " + roles.length}</div>
          <div>
            <button className="admin-add-button" onClick={handleAddRole}>{t.add + " " + t.role} <FontAwesomeIcon icon={faPlus} /></button>
          </div>
        </div>
        <div className="admin-list-box">
          <div className="admin-list-header grid-cols-5 px-4 py-2">
            <div>{t.role}</div>
            <div>{t.amount_of + " " + t.rights}</div>
            <div>{t.amount_of + " " + t.rooms}</div>
            <div>{t.amount_of + " " + t.users}</div>
          </div>

          {roles && roles.map((role, index) => (
            <div
              key={index}
              className="grid md:grid-cols-5 items-center px-3 py-2 rounded-md m-2 bg-[var(--white-color)]"
            >
              <div className="font-medium">{role.name}</div>
              <div>
                <span className="block md:hidden">{t.amount_of + " " + t.rights + ": "}</span>
                {role.Acls.length}
              </div>
              <div>
                <span className="block md:hidden">{t.amount_of + " " + t.rooms + ": "}</span>
                <h3>{role.Rooms.length}</h3>
              </div>
              <div>
                <span className="block md:hidden">{t.amount_of + " " + t.users + ": "}</span>
                <h3>{role.userCount}</h3>
              </div>
              <div className="text-right">
                <button className="admin-edit-button" onClick={() => handleEditRole(role)}> 
                  {t.edit} <FontAwesomeIcon icon={faPenToSquare} />
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {showOverlay && (
        <Overlay
          isOpen={showOverlay}
          onClose={closeOverlay}
          role={overlayRole}
          acls={acls}
          rooms={rooms}
          createNew={createNew}
          onRefresh={fetchRoles}
        />
      )}
    </>
  );
};

export default Roles;
